<template>
  <PLogin />
</template>

<script>
import PLogin from '@/components/p-login/index.vue';
export default {
  components: {
    PLogin,
  },

};
</script>
